import { render, staticRenderFns } from "./DashboardOrdersStatsConfig.component.vue?vue&type=template&id=5935615e&scoped=true&"
import script from "./DashboardOrdersStatsConfig.component.vue?vue&type=script&lang=js&"
export * from "./DashboardOrdersStatsConfig.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935615e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
